module.exports = __webpack_public_path__ + "img/G_Art_Claw_R_2_3_4.7fc9d280.png";